export default __webpack_public_path__ + "static/media/upload_failed.d1d6ae8b.svg";